module.exports = __webpack_public_path__ + "static/assets/5cbbcdd7267ca6ab1e5e811095670d07.gif";